<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      id: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      valid: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      classes () {
        return {
          'has-error': !this.valid
        }
      }
    }
  }
</script>

<template>
  <div
    class="e-input"
    :class="classes"
  >
    <label
      v-if="label"
      :for="id"
      class="label"
    >
      {{ label }}
    </label>
    <div class="input-container">
      <input
        :id="id"
        ref="input"
        :placeholder="placeholder"
        :disabled="disabled"
        :value="value"
        v-bind="$attrs"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur')"
      >
    </div>
    <div class="error-container">
      <slot name="error" />
    </div>
  </div>
</template>

<style lang="scss">

  .e-input {
    @apply relative;

    .label {
      @apply text-base pb-1 inline-block;
    }

    .input-container {
      @apply relative;

      input {
        @apply w-full rounded-sm h-12 border-black border-2 px-3 leading-none outline-none appearance-none;

        &:placeholder-shown {
          @apply border-gray-200;
        }

        &:hover,
        &:focus
        {
          @apply border-black;
        }

        &:disabled {
          @apply border-gray-200 cursor-not-allowed;
        }

      }
    }

    &.has-error .input-container input {
      @apply border-red-500;
    }

    .error-container {
      @apply text-red-500;

      > * {
        @apply pt-1;
      }

    }

  }

</style>
